export type Maybe<T> = NULLABLE<T> | UNDEFINED<T>;

export type PickNullable<T, K extends keyof T> = { [P in K]?: Maybe<T[P]> };

/**
 * Defines all properties of T as required and not nullable.
 */
export type RequiredNonNullable<T> = {
  [P in keyof T]-?: NonNullable<T[P]>;
};

export function getIsNullable(value: any): value is null | undefined {
  return value === null || value === undefined;
}

export function getIsNotNullable<T>(value: Maybe<T>): value is T {
  return !getIsNullable(value);
}

export function getValueOrDefault<T>(value: Maybe<T>, defaultValue: NonNullable<T>): T {
  return getIsNotNullable(value) ? value : defaultValue;
}

/**
 * Asserts that the given keys of the input object are NonNullable, with proper type inference.
 */
export function getIsNotNullableProps<T, K extends keyof T>(
  obj: T,
  ...keys: K[]
): obj is T & RequiredNonNullable<{ [P in K]: T[P] }> {
  return keys.every(key => getIsNotNullable(obj[key]));
}
